import classNames from "classnames/bind";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { InputTextBox, Row, SearchSelect, Toast } from "../../../../components";
import { HintIcon } from "../../../../components/Icons/Icons";
import useFetchData from "../../../../hooks/useFetchData";
import axiosClient from "../../../../services/axiosClient";
import { validatorInfoWareHouse } from "../../../../utils";
import styles from "./SideBarInfo.module.css";

const cx = classNames.bind(styles);

function SideBarInfo() {
    const [provinceCode, setProvinceCode] = useState({ name: null, code: null });
    const [districtCode, setDistrictCode] = useState({ name: null, code: null });
    const [communeCode, setCommuneCode] = useState({ name: null, code: null });
    const [address, setAddress] = useState('');
    const [nameWareHouse, setNameWareHouse] = useState('');
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [target, setTarget] = useState('')
    const [isToolTip, setIsToolTip] = useState(false);
    const refToolTip = useRef(null);
    const [dataDetail, setDataDetail] = useState();
    const [listCodeCameraInWareHouse, setListCodeCameraInWareHouse] = useState();
    const [submit, setSubmit] = useState(false);
    const navigate = useNavigate();
    const params = useParams();
    // get camera
    useEffect(() => {
        if (params.id) {
            const getDetailWareHouse = async (id) => {
                const res = await axiosClient.get(`/warehouse/get-list-warehouse/?warehouse_code=${id}`)
                const data = res.data[0]
                setDataDetail(data)
                return res
            }
            getDetailWareHouse(params.id)
        }
    }, [params])
    // get code camera
    useEffect(() => {
        if (params.id) {
            const getListCamera = async (code) => {
                const res = await axiosClient.get(`/cameraManagement/get-list-camera/?warehouse_code=${code}`)
                const data = res.data;
                const listCode = data.map((item) => {
                    return {
                        camera_code: item.CAMERA.CODE
                    }
                })
                setListCodeCameraInWareHouse(listCode)
            }
            getListCamera(params.id)
        }
    }, [params.id])

    //get longitude + latitude
    useEffect(() => {
        const extractTarget = (target) => {
            const data = target.trim()
            const index = data.trim().indexOf(',')
            setLongitude(data.slice(index + 2));
            setLatitude(data.slice(0, index));
        }
        extractTarget(target)
    }, [target])

    // get code info address
    const province = useFetchData("province/get-info-province/", {
        nation_code: "VNM",
        province_name: provinceCode.name,
    });
    const district = useFetchData(
        `district/get-list-district/?province_code=${provinceCode?.code}`, {
        district_name: districtCode.name
    }
    );
    const commune = useFetchData(
        `commune/get-list-commune/?district_code=${districtCode?.code}`, {
        commune_name: communeCode.name,
    }
    );

    const handleChangeProvince = (data, label) => {
        setProvinceCode({ code: data, name: label });
        setDistrictCode({ code: null, name: null });
        setCommuneCode({ code: null, name: null });
    };
    const handleChangeDistrict = (data, label) => {
        if (provinceCode.code) {
            setDistrictCode({ code: data, name: label });
            setCommuneCode({ code: null, name: null });
        } else {
            Toast.open('Vui lòng chọn tỉnh!', 'danger')
        }
    };
    const handleChangeCommune = (data, label) => {
        if (districtCode.code) {
            setCommuneCode({ code: data, name: label });
        } else {
            Toast.open('Vui lòng chọn huyện!', 'danger')
        }
    };
    const onChangeAddress = (data) => {
        setAddress(data);
    };
    const onChangeNameCamera = (data) => {
        setNameWareHouse(data);
    };

    const handleHoverTooltip = () => {
        setIsToolTip(true)
    }

    const onChangeTarget = (data) => {
        setTarget(data)
    }
    // handle tooltip
    useEffect(() => {
        const hideToolTip = (e) => {
            if (e.target !== refToolTip.current) {
                setIsToolTip(false)
            }
        }
        document.addEventListener('click', hideToolTip)
        return () => {
            document.removeEventListener('click', hideToolTip)
        }
    }, [])

    // set detail info
    useEffect(() => {
        if (dataDetail) {
            setProvinceCode({ code: dataDetail.PROVINCE_CODE, name: dataDetail.PROVINCE_NAME });
            setDistrictCode({ code: dataDetail.DISTRICT_CODE, name: dataDetail.DISTRICT_NAME })
            setCommuneCode({ code: dataDetail.COMMUNE_CODE, name: dataDetail.COMMUNE_NAME })
            setNameWareHouse(dataDetail.WAREHOUSE_NAME)
            setAddress(`${dataDetail.COMMUNE_NAME} - ${dataDetail.DISTRICT_NAME} - ${dataDetail.PROVINCE_NAME}`)
            setTarget(`${dataDetail.LATITUDE}, ${dataDetail.LONGITUDE}`)
        }
    }, [dataDetail])

    // change info
    const handleSaveNewInfo = async () => {
        const data = {
            province_code: provinceCode?.code,
            district_code: districtCode?.code,
            commune_code: communeCode?.code,
            address_detail: address,
            nation_code: 'VNM',
            note: 'note',
            subject_name: nameWareHouse,
            latitude: latitude,
            longitude: longitude,
            list_cam: {
                data: listCodeCameraInWareHouse
            }
        }
        setSubmit(true)
        if(validatorInfoWareHouse(data)) {
            try {
                const res = await axiosClient.put(`/warehouse/put-change-info-warehouse/?warehouse_code=${params.id}`, data)
                Toast.open('Cập nhật kho thành công', 'success')
                setTimeout(() => {
                    navigate('/admin/warehouse/', { replace: true })
                }, 1500);
                return res
            } catch (error) {
                Toast.open('Cập nhật kho không thành công', 'danger')
            }
        } else {
            Toast.open('Vui lòng điền đầy đủ thông tin', 'danger')
        }
    }
    // create new info
    const postCreateWareHouse = async (params) => {
        try {
            const res = await axiosClient.post('/warehouse/post-add-warehouse/', params)
            Toast.open('Tạo kho thành công', 'success')
            setTimeout(() => {
                navigate('/admin/warehouse/')
            }, 1000);
            return res
        } catch (error) {
            Toast.open('Tạo kho không thành công', 'danger')
        }
    }

    const handleCreateWareHouse = () => {
        const params = {
            province_code: provinceCode?.code,
            district_code: districtCode?.code,
            commune_code: communeCode?.code,
            address_detail: address,
            nation_code: 'VNM',
            note: '661',
            subject_name: nameWareHouse,
            longitude: longitude,
            latitude: latitude
        }
        setSubmit(true)
        if (validatorInfoWareHouse(params)) {
            postCreateWareHouse(params)
        } else {
            Toast.open('Vui lòng điền đầy đủ thông tin', 'danger')
        }
    }

    const formatData = (data, type) => {
        if (data.length > 0) {
            const dataFormat = data.map((item) => {
                switch (type) {
                    case 'province':
                        return {
                            name: item.PROVINCE_NAME,
                            code: item.PROVINCE_CODE,
                        }
                    case 'district':
                        return {
                            name: item.DISTRICT_NAME,
                            code: item.DISTRICT_CODE,
                        }
                    case 'commune':
                        return {
                            name: item.COMMUNE_NAME,
                            code: item.COMMUNE_CODE
                        }
                    default:
                        return null
                }
            })
            return dataFormat
        }
    }
    return (
        <div className={cx('info-container')}>
            <div id={'__notification'}></div>
            <InputTextBox
                style={{ marginBottom: 8 }}
                type="text"
                placeholder="Nhập"
                title="Tên kho *"
                onChange={onChangeNameCamera}
                value={nameWareHouse}
                error={nameWareHouse.trim().length === 0}
                titleError={'Tên kho không được để trống!'}
                submit={submit}
            />
            <InputTextBox
                style={{ marginBottom: 8 }}
                type="text"
                placeholder="Nhập"
                title="Địa điểm kho *"
                onChange={onChangeAddress}
                value={address}
                error={address.trim().length === 0}
                titleError={'Địa chỉ không được để trống!'}
                submit={submit}
            />
            <SearchSelect
                placeholder={'Quốc gia'}
                require
                value={'Việt Nam'}
                label={'Quốc gia'}
                disabled
            />
            <SearchSelect
                placeholder={'Tỉnh'}
                require
                value={provinceCode.name}
                onChange={handleChangeProvince}
                label={'Tỉnh'}
                dataMap={formatData(province.data, 'province')}
                error={submit && !provinceCode.code}
                message={'Tỉnh không được để trống!'}
            />
            <SearchSelect
                placeholder={'Huyện'}
                require
                value={districtCode.name}
                onChange={handleChangeDistrict}
                label={'Huyện'}
                dataMap={formatData(district.data, 'district')}
                error={submit && !districtCode.code}
                message={'Huyện không được để trống!'}
            />
            <SearchSelect
                placeholder={'Xã'}
                require
                value={communeCode.name}
                onChange={handleChangeCommune}
                label={'Xã'}
                dataMap={formatData(commune.data, 'commune')}
                error={submit && !communeCode.code}
                message={'Xã không được để trống!'}
            />
            <div className={cx('input-hint')}>
                <div className={cx('hint-icon')} onMouseEnter={handleHoverTooltip}>
                    <HintIcon />
                </div>
                <div className={cx('tooltip', isToolTip && 'hide')} ref={refToolTip}>
                    <div className={cx('wrapper')}>
                        <ul className={cx('list-hint')}>
                            <li className={cx('hint-item')}>
                                Trên máy tính, hãy mở <a href="https://www.google.com/maps" target={'_blank'} rel='noreferrer'>Google Maps</a>
                            </li>
                            <li className={cx('hint-item')}>
                                Nhấp chuột phải vào địa điểm hoặc khu vực đó trên bản đồ. Một cửa sổ bật lên sẽ xuất hiện. Bạn có thể tìm thấy vĩ độ và kinh độ ở định dạng thập phân ở trên cùng.
                            </li>
                            <li className={cx('hint-item')}>Để tự động sao chép toạ độ, hãy nhấp chuột trái vào vĩ độ và kinh độ.</li>
                        </ul>
                    </div>
                </div>
                <InputTextBox
                    style={{ marginBottom: 8 }}
                    type="text"
                    placeholder="Tọa độ"
                    title="Tọa độ kho *"
                    onChange={onChangeTarget}
                    value={target}
                    error={target.trim().length === 0}
                    titleError={'Tọa độ kho không được để trống!'}
                    submit={submit}
                />
            </div>
            <Row gap={[12, 12]}>
                {params.id ?
                    (<button onClick={handleSaveNewInfo} className={cx("btn-add")}>
                        Lưu cài đặt
                    </button>) :
                    (<button onClick={handleCreateWareHouse} className={cx("btn-add")}>
                        Tạo kho
                    </button>)}
                <Link style={{ textDecoration: "none" }} to="/admin/warehouse">
                    <button className={cx("btn-cancel")}>Hủy bỏ</button>
                </Link>
            </Row>
        </div>
    )
}

export default SideBarInfo;